import { Col, Row, Spin, Typography } from "antd";

const LoggingOutSpinner = () => {
    return (
        <Spin size="large" style={{ backgroundColor: 'transparent' }}>
            <Row justify="center">
                <Col xs={24} sm={22} md={20} lg={18} xl={16} className="loadingColApp">
                    <Typography.Title level={2} type="secondary">
                        Logging you out. Please wait!
                    </Typography.Title>
                </Col>
            </Row>
        </Spin>
    );
};

export default LoggingOutSpinner;